import { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Tabs from '../../tabs/tabs';
import formatDate from '../../../helpers/format-date';
import { SidepanelReadTypes } from './types';

import styles from '../transaction.module.css';

export default function InternalTransactionSidepanelRead({
  tabs,
  isWarning,
  parentRef,
  parentScroll = 0,
  transactionFee,
  warningsCount,
  sendMessage,
  setSubPanelVisible,
  setSelectedDocumentName,
  setGlTransactionSidePanelVisible,
  onGlTransactionClick,
  getTransactionDocument,
  deletedAt,
}: SidepanelReadTypes): React.JSX.Element {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [tabsList, setTabsList] = useState([
    {
      name: 'General Info',
      path: tabs?.generalPath || '',
    },
    {
      name: 'Warning',
      path: tabs?.warningPath || '',
    },
    {
      name: 'Status log',
      path: tabs?.logPath || '',
    },
    {
      name: 'Change log',
      path: tabs?.changeLogPath || '',
    },
    {
      name: 'Comments',
      path: tabs?.commentsPath || '',
    },
  ]);

  useEffect(() => {
    if (!transactionFee) {
      let list = [
        {
          name: 'General Info',
          path: tabs?.generalPath || '',
        },
        {
          name: 'Warning',
          path: tabs?.warningPath || '',
        },
        {
          name: 'AML & KYC',
          path: tabs?.amlPath || '',
        },
        {
          name: 'Status log',
          path: tabs?.logPath || '',
        },
        {
          name: 'Change log',
          path: tabs?.changeLogPath || '',
        },
        {
          name: 'Documents',
          path: tabs?.documentsPath || '',
        },
        {
          name: 'Chat',
          path: tabs?.chatPath || '',
        },
        {
          name: 'Comments',
          path: tabs?.commentsPath || '',
        },
      ];

      if (tabs?.accountingEntriesPath) {
        list = [
          {
            name: 'General Info',
            path: tabs?.generalPath || '',
          },
          {
            name: 'Warning',
            path: tabs?.warningPath || '',
          },
          {
            name: 'AML & KYC',
            path: tabs?.amlPath || '',
          },
          {
            name: 'Status log',
            path: tabs?.logPath || '',
          },
          {
            name: 'Change log',
            path: tabs?.changeLogPath || '',
          },
          {
            name: 'Documents',
            path: tabs?.documentsPath || '',
          },
          {
            name: 'Accounting entries',
            path: tabs?.accountingEntriesPath || '',
          },
          {
            name: 'Chat',
            path: tabs?.chatPath || '',
          },
          {
            name: 'Comments',
            path: tabs?.commentsPath || '',
          },
        ];
      }
      setTabsList(list);
    }
  }, [tabs, transactionFee]);

  useEffect(() => {
    if (tabs?.signaturePath) {
      let list = [
        {
          name: 'General Info',
          path: tabs?.generalPath || '',
        },
        {
          name: 'Warning',
          path: tabs?.warningPath || '',
        },
        {
          name: 'AML & KYC',
          path: tabs?.amlPath || '',
        },
        {
          name: 'Status log',
          path: tabs?.logPath || '',
        },

        {
          name: 'Change log',
          path: tabs?.changeLogPath || '',
        },
        {
          name: 'Signatures',
          path: tabs?.signaturePath || '',
        },
        {
          name: 'Documents',
          path: tabs?.documentsPath || '',
        },
        {
          name: 'Chat',
          path: tabs?.chatPath || '',
        },
        {
          name: 'Comments',
          path: tabs?.commentsPath || '',
        },
      ];

      if (tabs?.accountingEntriesPath) {
        list = [
          {
            name: 'General Info',
            path: tabs?.generalPath || '',
          },
          {
            name: 'Warning',
            path: tabs?.warningPath || '',
          },
          {
            name: 'AML & KYC',
            path: tabs?.amlPath || '',
          },
          {
            name: 'Status log',
            path: tabs?.logPath || '',
          },

          {
            name: 'Change log',
            path: tabs?.changeLogPath || '',
          },
          {
            name: 'Signatures',
            path: tabs?.signaturePath || '',
          },
          {
            name: 'Documents',
            path: tabs?.documentsPath || '',
          },
          {
            name: 'Accounting entries',
            path: tabs?.accountingEntriesPath || '',
          },
          {
            name: 'Chat',
            path: tabs?.chatPath || '',
          },
          {
            name: 'Comments',
            path: tabs?.commentsPath || '',
          },
        ];
      }
      setTabsList(list);
    }
  }, [tabs]);

  return (
    <>
      {deletedAt && (
        <div className={styles.deleted}>{`Transaction deleted ${formatDate(
          deletedAt,
          true,
        )}`}</div>
      )}
      <Tabs
        enableRouting
        tabs={tabsList}
        hideWarningTabs={!isWarning}
        isTransactionsTabs
        withSticky
        warningsCount={warningsCount}
        // eslint-disable-next-line react-hooks/refs
        withShadow={parentScroll > Number(scrollRef.current?.offsetTop) - 130}
        onRouterClick={() => {
          if (parentScroll >= Number(scrollRef.current?.offsetTop) - 130) {
            parentRef?.current?.scrollTo({
              top: Number(scrollRef.current?.offsetTop) - 130,
            });
          }
        }}
        moreButtonClassName={styles.transactionMoreButton}
      />
      <div ref={scrollRef} className={styles.sidepanelContentWrapper}>
        <Outlet
          context={{
            sendMessage,
            setSubPanelVisible,
            setSelectedDocumentName,
            setGlTransactionSidePanelVisible,
            onGlTransactionClick,
            getTransactionDocument,
          }}
        />
      </div>
    </>
  );
}
